import { render, staticRenderFns } from "./backup-db.vue?vue&type=template&id=2c28eb4f"
import script from "./backup-db.vue?vue&type=script&lang=js"
export * from "./backup-db.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports